module.exports = __webpack_public_path__ + "static/media/021yhkgl.6184e880.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/021yhkgl.jpg
// module id = 637
// module chunks = 0 1